<template>
  <div :class="$style.base" v-test="'locations-list'">
    <Location
      v-for="(location, index) in company.locations"
      :key="index"
      :location="location"
      @click="selectLocation(location.id)"
      v-test="'location'"
    />
  </div>
</template>

<script setup lang="ts">
import { useBookingStore } from '@/stores/booking';
import { useCompanyStore } from '@/stores/company';
import { inject } from 'vue';
import Location from './Location.vue';

defineOptions({ name: 'ChooseLocation' });
const emit = defineEmits(['submit']);
const gtag = inject<any>('gtag');
const { company } = useCompanyStore();

const selectLocation = (locationId: string) => {
  const booking = useBookingStore();
  booking.locationId = locationId;

  emit('submit');

  gtag.trackEvent('location_select', {
    location_id: locationId
  });
};
</script>

<style lang="scss" module>
.base {
  padding: $spacing;
}
</style>
